import { c as _c } from "react/compiler-runtime";
import { Rating } from "@mantine/core";
export default function ProductReviews(t0) {
  const $ = _c(7);
  const {
    product
  } = t0;
  const t1 = product?.reviews_avg_rating || 0;
  let t2;
  if ($[0] !== t1) {
    t2 = <Rating value={t1} fractions={2} readOnly={true} size="10px" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = product?.reviews_count ? `${product.reviews_count}` : "No";
  let t4;
  if ($[2] !== t3) {
    t4 = <p className="text-xs font-medium opacity-70">{t3} Reviews</p>;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t2 || $[5] !== t4) {
    t5 = <div className="flex gap-1 justify-center items-center">{t2}{t4}</div>;
    $[4] = t2;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}